// Formatting shared by Trade History and the trade detail view.

// Times arrive as text from the bot. Safari (iPhone) rejects "2026-11-04 17:00:00+00:00" (space instead
// of "T"), more than 3 fractional digits and "+0000"-style offsets, so normalise before new Date().
// Naive times are UTC. Returns a valid Date or null.
export function parseTime(v) {
  if (v == null || v === "") return null;
  if (v instanceof Date) return isNaN(v) ? null : v;
  if (typeof v === "number") return new Date(v < 1e12 ? v * 1000 : v);
  let s = String(v).trim();
  const m = s.match(/^(\d{4}-\d{2}-\d{2})[ T](\d{2}:\d{2}(?::\d{2})?)(\.\d+)?\s*(Z|[+-]\d{2}:?\d{2})?$/i);
  if (m) {
    const frac = m[3] ? m[3].slice(0, 4) : "";
    let tz = (m[4] || "Z").toUpperCase();
    if (tz !== "Z" && !tz.includes(":")) tz = `${tz.slice(0, 3)}:${tz.slice(3)}`;
    s = `${m[1]}T${m[2]}${frac}${tz}`;
  }
  const d = new Date(s);
  return isNaN(d) ? null : d;
}

export const toUnix = (v) => {
  const d = parseTime(v);
  return d ? Math.floor(d.getTime() / 1000) : null;
};

export const fmtDateTime = (v, opts = { month: "short", day: "numeric", hour: "2-digit", minute: "2-digit" }) => {
  const d = parseTime(v);
  return d ? d.toLocaleString(undefined, opts) : "—";
};

export const fmtPnl = (v) => {
  if (v == null) return "$0.00";
  const sign = v > 0 ? "+" : v < 0 ? "-" : "";
  return `${sign}$${Math.abs(v).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
};

export const pnlCls = (v) => (v > 0 ? "ops-long" : v < 0 ? "ops-short" : "text-[hsl(var(--ops-text))]");

export const fmtPrice = (v) =>
  typeof v === "number" && isFinite(v)
    ? v.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })
    : "—";
